import React from 'react';
import { TransphereUnappliedIndicator } from './TransphereUnappliedIndicator';
import { TransphereUnsentInvoicesIndicator } from './TransphereUnsentInvoicesIndicator';
import { TransphereUnappliedIndicatorSkeleton } from './TransphereUnappliedIndicatorSkeleton';
import type { TransphereIndicatorDto } from '../../types/transphere/transphereIndicator';
import type { TransphereUnsentInvoicesDto } from '../../types/transphere/transphereUnsentInvoices';

interface ReliabilityIndicatorsProps {
    unapplied: TransphereIndicatorDto | null;
    unsent: TransphereUnsentInvoicesDto | null;
    pending: boolean;
    onApplyPayments?: () => void;
    onOpenUnsentInvoices?: () => void;
}

/**
 * The reliability notices under the greeting, unapplied payments before unsent: a customer who may already
 * have paid is a more urgent correction than one missing from the list entirely.
 */
export const ReliabilityIndicators: React.FC<ReliabilityIndicatorsProps> = ({
    unapplied,
    unsent,
    pending,
    onApplyPayments,
    onOpenUnsentInvoices,
}) => {
    if (pending) return <TransphereUnappliedIndicatorSkeleton />;
    if (!unapplied && !unsent) return null;

    return (
        <div data-testid="reliability-indicators" className="flex flex-col gap-s">
            {unapplied && (
                <TransphereUnappliedIndicator
                    totalAmount={unapplied.totalAmount}
                    onApply={onApplyPayments}
                />
            )}
            {unsent && (
                <TransphereUnsentInvoicesIndicator
                    count={unsent.count}
                    onOpen={onOpenUnsentInvoices}
                />
            )}
        </div>
    );
};
